import { KeyValuePipe, NgForOf, NgIf } from "@angular/common";
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { Router, RouterLink } from "@angular/router";
import * as _ from 'lodash';
import { DialogModule } from "primeng/dialog";
import { DropdownModule } from "primeng/dropdown";
import { FileUploadModule } from "primeng/fileupload";
import { InputTextModule } from "primeng/inputtext";
import { InputTextareaModule } from "primeng/inputtextarea";
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from "primeng/radiobutton";
import { TooltipModule } from "primeng/tooltip";
import { environment } from '../../environments/environment';
import { ECollection } from '../enums/ECollection';
import { EOrderStatus } from "../enums/EOrderStatus";
import { EProductGroupType } from '../enums/EProductGroupType';
import { IProducts_P } from "../interfaces/IProducts";
import { AddOrderService } from "../service/add-order.service";
import { AuthService } from "../service/auth.service";
import { DataProviderService } from '../service/data-provider.service';
import { EventS } from '../service/event.s';
import { NotificationService } from "../service/notification.service";
import { OrderCheckoutService } from "../service/order-checkout.service";
import { OrderFileUploadService } from "../service/order-file-upload.service";
import { TaxesService } from '../service/taxes.service';
import { UserService } from "../service/user.service";

@Component({
    selector: 'app-product-order',
    standalone: true,
    imports: [InputTextModule, ReactiveFormsModule, TooltipModule, DropdownModule, RadioButtonModule, NgIf, InputTextareaModule, FormsModule, RouterLink, FileUploadModule, NgForOf, DialogModule, ProgressSpinnerModule, KeyValuePipe],
    templateUrl: './product-order.component.html',
    styleUrl: './product-order.component.scss'
})
export class ProductOrderComponent implements OnInit, OnChanges {
    loading: boolean = false;
    checkoutForm: FormGroup;
    allOrdersRaw: any;
    allOrdersFlat: Order[] = [];
    filterGstProducts: Order[] = [];
    filterNonGstProducts: Order[] = [];
    currentProductOrdered: IProducts_P = <any>{};

    shipping: number = 0;
    shippingWithGst: number = 0;

    transportCharge: number = 0;
    transportWithGstCharge: number = 0;

    totalOrderAmount: number = 0;
    totalGstAmount: number = 0;
    totalGstCharge: number = 0;

    fullAddressObject: any | undefined;
    totalOrders: number = 0;
    selectedDeliveryType: any;

    visible: boolean = false;
    uploadedFiles: any[] = [];
    // currentProductGroup: string = '';
    currentProductGroupCategory: string = '';
    progress: { [key: string]: number } = {};
    intervals: any = {};

    @Output() count = new EventEmitter<number>();
    @Input() productGroupId: string = '';
    @Input() productName: string = '';
    @ViewChild('fileUploader') fileUploader: any;

    delivery: deliver[] = [
        { name: 'Porter', code: 'Porter' },
        { name: 'Collect From Office', code: 'Collect_From_Office' }
    ];
    Number = Number;

    EProductGroupType = EProductGroupType;

    tax: number = 0;

    constructor(
        private fb: FormBuilder,
        private addOrderService: AddOrderService,
        public authService: AuthService,
        private orderCheckoutService: OrderCheckoutService,
        private userService: UserService,
        private eventCenterS: EventS,
        private ns: NotificationService,
        private taxesService: TaxesService,
        private router: Router,
        private dataProvider: DataProviderService,
        private orderFileUploadService: OrderFileUploadService,
    ) {
        this.checkoutForm = this.fb.group({
            selectedDelivery: ['', Validators.required],
            parcelAddress: [''],
            parcelNumber: ['', Validators.min(0)],
            ingredient: ['Delivery'],
            text: [''],
            defaultAddress: ['', Validators.required],
            jobName: [''],
            message: ['']
        });
    }


    async ngOnInit() {
        if (this.authService?.gUser?._id) {
            this.eventCenterS.loadAddToCardProducts.subscribe(async (data: boolean) => {
                if (data) await this.getOrders();
            });

            await this.getOrders();
            // this.totalOrderAmount = this.allOrdersFlat.reduce((acc: number, order: Order) => {
            //     return acc + Number(order.totalPrice);
            // }, 0);
            this.fullAddressObject = await this.getFullAddress();
            this.checkoutForm.patchValue({
                defaultAddress: this.fullAddressObject.fullAddress
            });
        }
    }

    async ngOnChanges(changes: SimpleChanges) {
        if (changes['productGroupId']?.previousValue !== changes['productGroupId']?.currentValue) {
            await this.getOrders();
            // console.log(changes['productGroupId']);
        }
        if (changes['productName']?.previousValue !== changes['productName']?.currentValue && !changes['productName'].previousValue) {
            this.uploadedFiles = [];
            this.fileUploader?.clear();
        }
    }

    async onUpload(event: any) {
        for (let file of event.files) {
            this.uploadedFiles.push(file);
            if (!this.isValidFile(file)) {
                this.ns.showError(`Invalid File: ${file.name} must be a .cdr, .jpeg, or .jpg`);
                continue;
            }

            this.progress[file.name] = 0;

            const interval = setInterval(() => {
                if (this.progress[file.name] < 100) {
                    this.progress[file.name] += 1;
                } else {
                    clearInterval(interval);
                    delete this.intervals[file.name];
                    this.ns.showSuccess("File upload successfully.");

                    setTimeout(() => {
                        delete this.progress[file.name];
                    }, 500); // waits before removing so user can see 100%
                }
            }, 25);
            this.intervals[file.name] = interval;
        }
    }

    showDialog() {
        this.visible = true;
    }

    /**
     * Allow only CorelDRAW .cdr or image files .jpeg/.jpg for uploads
     */
    isValidFile(file: any): boolean {
        const name = file.name.toLowerCase();
        return name.endsWith('.cdr') || name.endsWith('.jpeg') || name.endsWith('.jpg');
    }

    async fileUpload(files: File[]) {
        if (files.length) {
            const formData = new FormData();
            formData.append('bucketName', environment.BUCKET_NAME);
            files.forEach((file: File) => formData.append('files', file));
            try {
                return await this.orderFileUploadService.fileUpload(formData);
            } catch (e: any) {
                this.ns.showError(`Invalid File`);
            }
        }
    }

    async getOrders() {
        let groupId = this.dataProvider.getDataForAddOrder().productGroupId;
        // console.log('groupID', groupId)

        this.allOrdersRaw = await this.addOrderService.query({
            find: {
                user_objid: this.authService.gUser?._id,
                active: true,
                productGroup_objid: groupId
            },
            deep: [
                {
                    s_key: "product_objid",
                    t_instance: environment.INS,
                    t_db: environment.DB,
                    t_col: ECollection.MP_PRODUCTS,
                    t_key: "_id",
                    select: {
                        mpp_productName_str: 1,
                        mpp_porterCharges_num: 1,
                        mpp_productGroup_objid: 1,
                        mpp_IsGstProduct_bl: 1,
                        mpp_productPrice_num: 1,
                        mpp_order_num: 1,
                        mpp_solvent_price_num: 1,
                        mpp_eco_price_num: 1,
                        mpp_uv_price_num: 1,
                        mpp_3mm_price_num: 1,
                        mpp_5mm_price_num: 1,
                    },
                    deep: [
                        {
                            s_key: "mpp_productGroup_objid",
                            t_instance: environment.INS,
                            t_db: environment.DB,
                            t_col: ECollection.MP_PRODUCT_GROUPS,
                            t_key: "_id",
                            select: {
                                mpg_tax_objid: 1,
                                mpg_porterCharges_num: 1,
                                mpg_hsnCode_num: 1,
                                mpg_productGroupCategory_str: 1,
                            }
                        }
                    ],
                }
            ],
        });
        this.currentProductOrdered = this.allOrdersRaw[0]?.product_objid;

        this.allOrdersFlat = this.allOrdersRaw.map((order: any) => {
            return {
                _id: order._id,
                productName: order.product_objid?.mpp_productName_str,
                productGroup: order.productGroup,
                productGroupName: order.productGroupName, // ✅ included explicitly
                productGroupCategory: order.productGroupCategory, // ✅ included explicitly
                productsGroup_objid: order.productGroup_objid, // ✅ included explicitly
                user_objid: order.user_objid,
                price: order.price,
                jobName: order.jobName,
                quantity: order.quantity,
                width: order.width,
                height: order.height,
                quality: order.quality,
                sheet: order.sheet,
                totalPrice: order.totalPrice,
                cdrFiles_arr: order.cdrFiles_arr,
                createdAt: order.createdAt,
                active: order.active,
                product_objid: order.product_objid
            } as Order;
        });
        this.totalOrders = this.allOrdersFlat.length;
        this.count.emit(this.totalOrders);
        // let ProductGroup = this.allOrdersFlat[0]?.productGroup as any;
        // this.currentProductGroup = this.allOrdersFlat[0]?.productGroup ? this.allOrdersFlat[0]?.productGroup : '';
        this.currentProductGroupCategory = this.allOrdersFlat[0]?.productGroupCategory ? this.allOrdersFlat[0]?.productGroupCategory : '';

        this.filterGstProducts = this.allOrdersFlat.filter((e: any) => e.product_objid?.mpp_IsGstProduct_bl === true);
        this.filterNonGstProducts = this.allOrdersFlat.filter((e: any) => e.product_objid?.mpp_IsGstProduct_bl === false || !e.product_objid?.mpp_IsGstProduct_bl);

        this.tax = 0;
        let taxMap = _.map(this.filterGstProducts, 'product_objid.mpp_productGroup_objid.mpg_tax_objid');
        let textResp = await this.taxesService.query({ find: { _id: { $in: taxMap } } });
        let keyByMap = _.keyBy(textResp, '_id');

        this.tax = keyByMap[this.allOrdersFlat[0]?.product_objid?.mpp_productGroup_objid?.mpg_tax_objid]?.mpt_rate_num;

        for (let item of <any>this.filterGstProducts) {
            if (keyByMap[item.product_objid?.mpp_productGroup_objid?.mpg_tax_objid]) {
                item.totalAmountGSTCharge = (Number(item.totalPrice) * keyByMap[item.product_objid?.mpp_productGroup_objid?.mpg_tax_objid]?.mpt_rate_num) / 100;
            }
        }

        if (this.filterGstProducts && this.filterGstProducts.length) {
            this.totalGstAmount = this.filterGstProducts.reduce((acc: number, order: Order) => {
                return acc + Number(order.totalPrice);
            }, 0);

            this.shippingWithGst = _.sumBy(this.filterGstProducts, (e: any) => e.product_objid?.mpp_porterCharges_num);
            // this.transportWithGstCharge = _.sumBy(this.filterGstProducts, (e: any) => e.product_objid?.mpp_porterCharges_num);
            this.totalGstCharge = _.sumBy(this.filterGstProducts, (e: any) => e.totalAmountGSTCharge);
        }

        if (this.filterNonGstProducts && this.filterNonGstProducts.length) {
            this.totalOrderAmount = this.filterNonGstProducts.reduce((acc: number, order: Order) => {
                return acc + Number(order.totalPrice);
            }, 0);

            this.shipping = _.sumBy(this.filterNonGstProducts, (e: any) => e.product_objid?.mpp_porterCharges_num);
            // this.transportCharge = _.sumBy(this.filterNonGstProducts, (e: any) => e.product_objid?.mpp_porterCharges_num);
        }
    }

    async getFullAddress() {
        let reqBody = {
            find: { _id: this.authService.gUser?._id },
            select: 'usr_address_str, usr_cityName_str, usr_district_str, usr_state_str, usr_pincode_num',
        };
        let res = await this.userService.amUserQuery(reqBody);
        if (!res || res.length === 0) return { fullAddress: '', cityName: '' };
        let addressObj = res[0];
        let parts = [
            addressObj.usr_address_str,
            addressObj.usr_cityName_str,
            addressObj.usr_state_str,
            addressObj.usr_pincode_num
        ].filter(Boolean); // removes null/undefined/empty
        return {
            fullAddress: parts.join(', '),
            cityName: addressObj.usr_cityName_str
        };
    }

    async changeQuantity(order: Order) {
        try {
            let resp = await this.addOrderService.put(order._id, {
                quantity: order.quantity,
                totalPrice: this.subTotalProduct(order),
            }, { select: '_id' });
            if (resp && resp._id) {
                this.ns.showSuccess('Quantity updated successfully.');
                await this.getOrders();
            }
        } catch (e: any) {
            this.ns.showErrorFromResponse(e.error || e, 'Unable to update data.');
        }
    }

    async deleteOrder(order: Order) {
        try {
            let res = await this.addOrderService.permanentDelete(order._id);
            if (res) {
                this.allOrdersFlat = this.allOrdersFlat.filter((o: Order) => o._id !== order._id);
                this.totalOrders = this.allOrdersFlat.length;
                this.count.emit(this.totalOrders);
                this.eventCenterS.loadAddToCard.next(true);
                await this.getOrders();
                // this.totalOrderAmount = this.allOrdersFlat.reduce(
                //     (acc: number, o: Order) => acc + Number(o.totalPrice),
                //     0
                // );
                this.ns.showSuccess('Item removed successfully.');
            }
        } catch (e: any) {
            this.ns.showErrorFromResponse(e.error || e, 'Unable to remove order');
        }
    }

    async onSubmit() {
        this.loading = true;
        if (!this.checkoutForm.get('selectedDelivery')?.value) {
            this.loading = false;
            return this.ns.showError('Please Select Delivery Type.');
        }
        if (!this.uploadedFiles.length) {
            this.loading = false;
            return this.ns.showError('Please Upload File.');
        }
        if (this.checkoutForm.valid) {
            let cdrFileUploadres = await this.fileUpload(this.uploadedFiles);
            if (!cdrFileUploadres?.length) {
                this.loading = false;
                return this.ns.showError('Please Upload File.');
            }

            let saveData = {
                mpr_companyName_objid: this.authService.gUser?._id,
                // mpr_orderNumber_str: Math.random().toString(36).slice(2, 6) + Math.floor(1000 + Math.random() * 9000),
                mpr_billDate_dt: new Date(),
                mpr_cityName_str: this.authService.gUser.usr_cityName_str,
                mpr_deliveryMode_str: this.checkoutForm.get("selectedDelivery")?.value,
                mpr_user_objid: this.authService.gUser?._id,
                mpr_itemDetails_arr: this.allOrdersFlat.map((order: Order) => ({
                    productName: order.productName,
                    products_objid: order?.product_objid?._id,
                    productGroupCategory: order.productGroupCategory,
                    productGroup: order.productGroup,
                    productsGroup_objid: order.productsGroup_objid,
                    // productGroupName: order.productGroupName,
                    user_objid: this.authService.gUser?._id,
                    price: order.price,
                    jobName: order.jobName,
                    quantity: order.quantity,
                    height: order.height,
                    width: order.width,
                    quality: order.quality,
                    sheet: order.sheet,
                    totalPrice: (Number(order.totalPrice)).toString(),
                    // specialRemark: order.specialRemark,
                    // cdrFiles_arr: order.cdrFiles_arr || [],
                    cdrFiles_arr: cdrFileUploadres || [],
                    createdAt: new Date(),
                    active: true,
                    hsnCode: order.product_objid?.mpp_productGroup_objid?.mpg_hsnCode_num || null,
                })),
                mpr_totalAmount: this.roundOffTotal(),
                mpr_roundOff: Number(this.roundOffAmount().toFixed(2)),
                mpr_subTotalAmount: Number((this.subtotal).toFixed(2)),
                mpr_gstTotal: Number(this.gstTotal.toFixed(2)),
                mpr_porterCharges_num: 0,
                mpr_address: this.checkoutForm.get("text")?.value || this.checkoutForm.get("defaultAddress")?.value,
                mpr_parcel_nos: this.checkoutForm.get("parcelNumber")?.value,
                mpr_order_status: EOrderStatus.IN_PROGRESS,
                mpr_dispatch_bl: false,
                mpr_dispatchDate_dt: "",
                mpr_docketNumber_str: "",
                mpr_special_remark_str: this.checkoutForm.get("message")?.value || ''
            };

            if (this.selectedDeliveryType === 'Porter') {
                saveData.mpr_porterCharges_num = Number(this.porterCharges.toFixed(2));
                saveData.mpr_parcel_nos = null;
            }
            if (this.selectedDeliveryType === 'Collect_From_Office') {
                saveData.mpr_parcel_nos = null;
            }

            try {
                const res = await this.orderCheckoutService.orderPlaceEmailOrNotification(saveData);
                if (res) {
                    this.allOrdersFlat = [];
                    this.totalOrders = 0;
                    this.count.emit(this.totalOrders);
                    this.ns.showInfo("Order successfully placed");
                    this.eventCenterS.loadAddToCard.next(true);
                    this.checkoutForm.get("message")?.setValue(null);
                    this.userService.gUser.next({ action: 'REFRESH_G_USER' });
                    this.loading = false;
                    setTimeout(async () => {
                        await this.router.navigate(['/myaccount']);
                    }, 1000);
                }
            } catch (e: any) {
                this.loading = false;
                this.ns.showErrorFromResponse(e.error || e, 'Something went wrong');
            }
        } else {
            this.loading = false;
            this.ns.showError("Please fill all required details");
        }
    }

    onDeliveryChange(value: any) {
        this.selectedDeliveryType = this.checkoutForm.get('selectedDelivery')?.value;
        if (this.selectedDeliveryType === 'Transport') this.checkoutForm.get('parcelNumber')?.setValue(1);
    }

    get subtotal() {
        this.totalOrderAmount = this.filterNonGstProducts.reduce((acc: number, order: Order) => {
            return acc + Number(order.totalPrice);
        }, 0);

        this.totalGstAmount = this.filterGstProducts.reduce((acc: number, order: Order) => {
            return acc + Number(order.totalPrice);
        }, 0);

        return this.totalOrderAmount + this.totalGstAmount;
    }

    subTotalWithCharge(): number {
        return Number((this.subtotal).toFixed(2));
    }

    total(): number {
        let shippingCharge = 0;
        const orders = this.allOrdersFlat ?? [];

        switch (this.selectedDeliveryType) {
            case 'Porter':
                shippingCharge = this.porterCharges;
                break;
            case 'Collect_From_Office':
            default:
                shippingCharge = 0;
        }

        return Number((this.subtotal + this.gstTotal + shippingCharge).toFixed(2));
    }

    roundOffAmount(): number {
        const actualTotal = this.total();
        const roundedTotal = Math.round(actualTotal);
        return Number((roundedTotal - actualTotal).toFixed(2));
    }

    roundOffTotal(): number {
        return Math.round(this.total());
    }


    subTotalProduct(order: Order): number {
        if (!order?.price || !order?.quantity) return 0;
        let pricePerUnit = Number(order.price);
        const quantity = Number(order.quantity);

        let total: number = 0;

        if (order.productGroupCategory === EProductGroupType.VINYL_SQ_FT || order.productGroupCategory === EProductGroupType.SPECIAL_MEDIA_SQ_FT || order.productGroupCategory === EProductGroupType.SHEET_BOARD_SQ_FT_OR_SQ_INCH) {
            total = pricePerUnit * quantity * Number(order.width || 1) * Number(order.height || 1);
        }

        if (order.productGroupCategory === EProductGroupType.DISPLAY_ITEM_PCS) {
            total = pricePerUnit * quantity;
        }

        if (quantity && order.productGroupCategory === EProductGroupType.BANNER_SQ_FT) {
            const quality = order.quality;
            const sheet = order.sheet;

            if (quality) {
                if (quality === 'SOLVENT') pricePerUnit += Number(this.currentProductOrdered.mpp_solvent_price_num);
                if (quality === 'ECO') pricePerUnit += Number(this.currentProductOrdered.mpp_eco_price_num);
                if (quality === 'UV') pricePerUnit += Number(this.currentProductOrdered.mpp_uv_price_num);
            }
            if (sheet) {
                if (sheet === '3MM') pricePerUnit += Number(this.currentProductOrdered.mpp_3mm_price_num);
                if (sheet === '5MM') pricePerUnit += Number(this.currentProductOrdered.mpp_5mm_price_num);
            }
            total = pricePerUnit * quantity * Number(order.width || 1) * Number(order.height || 1);
        }

        return Number(total.toFixed(2));
    }


    get porterCharges() {
        if (this.selectedDeliveryType === 'Porter') {
            return ((this.shipping || 0) + (this.shippingWithGst || 0));
            // return ((this.shipping || 0) + (this.shippingWithGst || 0)) * (Number(this.allOrdersFlat[0]?.quantity));
        } else return 0;
    }

    get gstTotal() {
        let shippingCharge = 0;
        if (this.selectedDeliveryType === 'Porter') shippingCharge = this.porterCharges * this.tax / 100;
        if (this.selectedDeliveryType === 'Collect_From_Office') shippingCharge = 0;

        return Number(this.totalGstCharge + shippingCharge) || 0;
    }

    onParcelInput(event: any) {
        if (event.target.value < 0) {
            event.target.value = 0;
            this.checkoutForm.get('parcelNumber')?.setValue(0);
        }
    }

    removeFile($event: any) {
        this.uploadedFiles = this.uploadedFiles.filter(file => file != $event.file);
    }

    clearFiles() {
        this.uploadedFiles = [];
    }
}

interface deliver {
    name: string;
    code: string;
}

interface Order {
    _id: string;
    productName: string;
    product_objid: any;
    productGroup: string;
    productGroupName?: string;
    productGroupCategory?: string;
    productsGroup_objid?: string;
    user_objid: string;
    price: string | number;
    jobName: string;
    quantity: string | number;
    extra: string | number;
    width: string | number;
    height: string | number;
    quality: string | number;
    sheet: string | number;
    totalPrice: string | number;
    squareAndRegular?: string;
    specialRemark?: string;
    cdrFiles_arr?: any[];
    createdAt?: string | Date;
    active: boolean;
}
